package com.essntl.features.dashboard.ui.components.itemcard

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import core.dateformat.utils.convertTimestampToTimeAgo
import core.dateformat.utils.formatToFullString
import core.dateformat.utils.stringToLocalDate
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.allproposal.components.ProposalStatus
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.*
import core.dateformat.ui.formatDate
import kotlinx.datetime.LocalDate

@Composable
fun ItemProposalCard(
    proposal: ProposalModel,
    selectedId: String?,
    onClick: () -> Unit,
) {
    val isSelected = rememberEquals(proposal.id, setOf(selectedId)) { it }

    EsTooltip(
        text = "Changed ${stringToLocalDate(proposal.statusUpdatedAt)?.formatToFullString() ?: "-"}",
    ) {
        Column(
            verticalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .width(250.dp)
                .height(150.dp)
                .clip(RoundedCornerShape(16.dp))
                .background(
                    color = when {
                        isSelected ->
                            MaterialTheme.esColorScheme.tintedPressed

                        else -> MaterialTheme.esColorScheme.bgPrimary
                    },
                )
                .border(
                    width = 1.dp,
                    color = if (proposal.status != null) {
                        when (proposal.status!!) {
                            ProposalModel.Status.Todo -> MaterialTheme.esColorScheme.bgDisable
                            ProposalModel.Status.InProgress -> Orange900
                            ProposalModel.Status.Sent -> MaterialTheme.esColorScheme.tintedPressed
                            ProposalModel.Status.Confirmed -> Green200
                            ProposalModel.Status.ItineraryReady -> Accent200
                            ProposalModel.Status.Accepted -> Green600
                            ProposalModel.Status.OnHold -> Red50
                            ProposalModel.Status.FollowedUp -> Green400
                            ProposalModel.Status.NotBooked -> Orange800
                        }
                    } else Color.Transparent,
                    shape = RoundedCornerShape(16.dp),
                )
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable(onClick = onClick)
                .padding(2.spacing),
        ) {
            Column {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text(
                        text = "v${proposal.version}",
                    )

                    proposal.status?.let {
                        ProposalStatus(
                            status = it,
                        )
                    }
                }

                Spacer(modifier = Modifier.height(1.spacing))

                Text(
                    text = proposal.title ?: "Proposal",
                    maxLines = 1,
                    style = MaterialTheme.esTypography.p1Medium16,
                    overflow = TextOverflow.Ellipsis,
                )
            }

            Spacer(modifier = Modifier.height(2.spacing))

            Column {
                proposal.statusUpdatedAt?.let {
                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Text(
                            text = "Status updated: ",
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textTertiary,
                        )

                        Text(
                            text = LocalDate.parse(it.substring(0, 10)).toString().formatDate("."),
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textTertiary,
                        )
                    }
                }

                Row {
                    Text(
                        text = "Created",
                        style = MaterialTheme.esTypography.p2Medium14.copy(
                            color = MaterialTheme.esColorScheme.textDisabled,
                        ),
                    )

                    Spacer(modifier = Modifier.width(1.spacing))

                    Text(
                        text = convertTimestampToTimeAgo(proposal.createdAt),
                        style = MaterialTheme.esTypography.p2Medium14.copy(
                            color = MaterialTheme.esColorScheme.textDisabled,
                        ),
                    )
                }
            }
        }
    }
}